import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { getAccessToken } from "@/common/keycloak/keycloak"

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: "",
    prepareHeaders: async (headers) => {
      const token = await getAccessToken()
      if (token) {
        headers.set("Authorization", `Bearer ${token}`)
      }

      return headers
    },
  }),
  endpoints: () => ({}),
})
